import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Json2csvService } from 'csvtools-lib';
import * as moment from 'moment';
import { DateUnixTransformerPipe } from 'src/app/pipes/date-unix-transformer-pipe/date-unix-transformer.pipe';
import { PriceToStringPipe } from 'src/app/pipes/price-to-string-pipe/price-to-string.pipe';
import { OrdersService } from 'src/app/services/orders-services/orders.service';

@Component({
  selector: 'app-orders-filter-orders-card',
  templateUrl: './orders-filter-orders-card.component.html',
  styleUrls: ['./orders-filter-orders-card.component.scss']
})
export class OrdersFilterOrdersCardComponent implements OnInit {

  @Input() data;
  show: boolean;
  refreshing: boolean;
  filterOrdersForm = new FormGroup({
    dateFrom: new FormControl(),
    dateTo: new FormControl(),
    timeFrom: new FormControl(),
    timeTo: new FormControl()
  });

  constructor(private ordersService: OrdersService,
              private json2csvService: Json2csvService,
              private dateUnixTrannsformerPipe: DateUnixTransformerPipe,
              private priceToStringPipe: PriceToStringPipe) { }

  ngOnInit() {
  }

  public showFilter() {
    this.show = !this.show;
  }

  public search() {
    const dateFrom = this.filterOrdersForm.get('dateFrom').value ? this.filterOrdersForm.get('dateFrom').value.valueOf() : null;
    const dateTo = this.filterOrdersForm.get('dateTo').value ? this.filterOrdersForm.get('dateTo').value.valueOf() : null;
    const timeFrom = (moment(this.filterOrdersForm.get('timeFrom').value, 'hh:mm').hour() * 3600000) + (moment(this.filterOrdersForm.get('timeFrom').value, 'hh:mm').minutes() * 60000);
    const timeTo = (moment(this.filterOrdersForm.get('timeTo').value, 'hh:mm').hour() * 3600000) + (moment(this.filterOrdersForm.get('timeTo').value, 'hh:mm').minutes() * 60000);
    const from = timeFrom ? dateFrom + timeFrom : dateFrom;
    const to = timeTo ? dateTo + timeTo : dateTo + (23 * 3600000) + (59 * 60000) + (59 * 1000);
    this.ordersService.refreshOrders(from , to);
    this.showFilter();
  }

  public clearField(fieldName) {
    this.filterOrdersForm.patchValue({
      [fieldName]: null
    });
  }

  public generateCSV() {
    const d = this.data.slice();
    d.forEach(i => i['creationDate'] = this.dateUnixTrannsformerPipe.transform(i['creationDate']));
    d.forEach(i => i['amount'] = this.priceToStringPipe.transform(i['amount']));
    this.json2csvService.setBody(d, ['creationDate', 'centerName', 'deviceName', 'app', 'currentStatus', 'paymentType', 'serviceType', 'nbArticles', 'amount', ]);
    this.json2csvService.setHeader(['Created', 'Center', 'Device', 'Application', 'Status', 'Payment', 'Service', 'Articles', 'Price']);
    this.json2csvService.generateCSV('orders');
  }
}
